import { onMounted, onUnmounted, ref } from 'vue';

// Handles both the modern (addEventListener) and legacy (addListener)
// MediaQueryList change-notification APIs — jsdom's own matchMedia stub
// (vitest.setup.ts) only implements the legacy one.
export function useMediaQuery(query: string) {
  const mediaQueryList = typeof window !== 'undefined' ? window.matchMedia(query) : undefined;
  const matches = ref(!!mediaQueryList?.matches);

  function update() {
    matches.value = !!mediaQueryList?.matches;
  }

  onMounted(() => {
    if (!mediaQueryList) return;
    update();
    if (mediaQueryList.addEventListener) mediaQueryList.addEventListener('change', update);
    else mediaQueryList.addListener?.(update);
  });

  onUnmounted(() => {
    if (!mediaQueryList) return;
    if (mediaQueryList.removeEventListener) mediaQueryList.removeEventListener('change', update);
    else mediaQueryList.removeListener?.(update);
  });

  return matches;
}
